require('../brokerTransferValuesStep.scss');
require('./brokerTransferValuesStep3.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const { formatText } = require('core/i18n').i18n;
// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const {
    BROKER_TRANSFER_VALUES_TYPE_TOTAL,
    BROKER_TRANSFER_VALUES_TYPE_PARTIAL,
    API_ENTERPRISE_NUMBER,
    API_CENTER
} = require('constants/index');
const {BROKER_TRANSFER_VALUES_TOTAL_ID, BROKER_TRANSFER_VALUES_PARTIAL_ID} = require('constants/operationTypes');

const BrokerTransferValuesStep3 = props => {
    const { immTransferValues } = props;
    const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
    const contractTo = immTransferValues.getIn(['steps', 0, 'accountIdTo']);
    const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);
    const immContractTo = immTransferValues.getIn(['steps', 0, 'accountsToOptions', contractTo]);
        const operative = formatText('operatives-valueTransfer');

    let serviceId;
    let operationParams = {
        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immContractFrom.get('productNumber')}${immContractFrom.get('walletNumber')}`,
        destinationAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immContractTo.get('productNumber')}${immContractTo.get('walletNumber')}`
    };

    if ( immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_TOTAL, 'selected']) ) {
        serviceId = BROKER_TRANSFER_VALUES_TOTAL_ID;
    }

    if ( immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'selected']) ) {
        serviceId = BROKER_TRANSFER_VALUES_PARTIAL_ID;

        const valueId = immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'id']);
        const immTitles = immTransferValues.getIn(['steps', 1, 'titles']);
        operationParams.bondsNumber = immTitles.get(valueId);
    }

    return (
        <article className="broker-transfer-values-step broker-transfer-values-step-three">
            <header className="broker-transfer-values-step__header">
                <FormattedText value="broker-transferValuesSecurityConfirmation" className="broker-transfer-values-step__title" />
            </header>
            <ContactCenterRender>
                <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
            </ContactCenterRender>
            <section className="broker-transfer-values-step__content">
                <FormattedText value="broker-transferValuesConfirmationMessage" />
            </section>
            <ContactCenterRender>
                <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
            </ContactCenterRender>
            <section className="broker-transfer-values-step__signature-pattern">
                <SignaturePattern
                    operationType={serviceId}
                    operationParams={operationParams}
                />
            </section>
        </article>
    )
};

BrokerTransferValuesStep3.propTypes = {
    immTransferValues: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
}

module.exports = BrokerTransferValuesStep3;
